(function (angular) {
  'use strict';

  angular
    .module('bossApp.bossError', [])
    .component('bossError', {
      templateUrl: 'src/app/components/bossError/bossError.template.html',
      controller: BossErrorCtrl,
      controllerAs: 'bossErrorCtrl',
      transclude: true,
      bindings: {
    	  showerror: '<'
      }
    });

  BossErrorCtrl.$inject = [];
  function BossErrorCtrl() {
    var ctrl = this;

    ctrl.error = false;
    ctrl.errorCode = '';

    ctrl.showerror = function (errorCode) {
    	alert(errorCode);
    	ctrl.error = true;
    	ctrl.errorCode = errorCode;
    };



  }


})(angular);
